<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import TaskService from "@/services/TaskService";
import DepartmentService from "@/services/DepartmentService";
import DateRangeMixin from "@/mixins/DateRangeMixin";

export default {
    mixins: [DateRangeMixin],
    components: { DateRangePicker },
    data() {
        return {
            loading: true,
            rows: [],
            departments: [],
            meta: {}
        };
    },
    computed: {
        currentExportUrl() {
            let params = this.$buildParams();
            params.csv = "1";

            let url = new URL(
                location.protocol +
                    "//" +
                    location.host +
                    "/v1/tasks/util-factor"
            );
            for (let param in params) {
                if (param == "dateRange") {
                    url.searchParams.append(
                        param,
                        JSON.stringify(params[param])
                    );
                } else {
                    if (Array.isArray(params[param])) {
                        // PHP way
                        params[param].forEach((v, idx) => {
                            url.searchParams.append(`${param}[${idx}]`, v);
                        });
                    } else {
                        url.searchParams.append(param, params[param]);
                    }
                }
            }

            return url.href;
        }
    },
    async created() {
        this.resetSearch();
        await this.fetchDepartments();
        this.$apiEnableWatcher();
        this.loading = false;
    },
    methods: {
        resetSearch() {
            this.apiSearchFilter = {
                dateRange: {
                    startDate: null,
                    endDate: null
                },
                department_id: ""
            };
        },
        async fetchData() {
            try {
                let params = this.$buildParams();
                const { data } = await TaskService.GET_utilFactor(params);
                this.rows = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("Error fetchData", e);
            }
        },
        async fetchDepartments() {
            try {
                const r = await DepartmentService.dropdown();

                this.departments = r.data.data;
            } catch (e) {
                console.log(e);
            }
        }
    }
};
</script>

<template>
    <div class="v-util-factor">
        <base-header class="pb-1" type=""><bread-bag></bread-bag></base-header>
        <div class="container-fluid">
            <div class="row card-wrapper" v-if="true">
                <div class="col-3">
                    <date-range-picker
                        class="range-picker"
                        ref="picker"
                        opens="right"
                        :timePicker="false"
                        :showWeekNumbers="true"
                        :autoApply="true"
                        v-model="apiSearchFilter.dateRange"
                        :linkedCalendars="true"
                        :locale-data="getDateRangePickerLocale()"
                        :ranges="getDateRangePickerRanges()"
                    >
                        <template #header>
                            <manual-range
                                :date-range-manual="dateRangeManual"
                                :date-range-error="dateRangeError"
                                @exec="
                                    execManualRange(
                                        'apiSearchFilter',
                                        'dateRange'
                                    )
                                "
                            />
                        </template>
                        <template
                            v-slot:input="picker"
                            style="min-width: 350px"
                        >
                            <template v-if="picker.startDate">
                                {{ $d(picker.startDate, "short") }}
                                -
                                {{ $d(picker.endDate, "short") }}
                            </template>
                        </template>
                    </date-range-picker>
                </div>
                <div class="col-3">
                    <FormulateInput
                        type="multiselect"
                        :options="departments"
                        v-model="apiSearchFilter.department_id"
                    />
                </div>
                <div class="col-6">
                    <base-button
                        v-if="false"
                        type="white"
                        @click="resetSearch"
                        :outline="false"
                        ><i class="far fa-redo"></i>
                        {{ $t("search.reset") }}</base-button
                    >
                    <a
                        :href="currentExportUrl"
                        class="btn btn-primary"
                        target="_blank"
                        >{{ $t("projects.download_as_csv") }}</a
                    >
                </div>
            </div>

            <div class="row card-wrapper mt-3">
                <div class="col-12">
                    <card body-classes="px-0">
                        <v-loader :loading="loading" v-if="loading" />
                        <template v-else-if="rows.length > 0">
                            <div>
                                <h3 class="mx-4">
                                    {{ $t("projects.period_sum") }}
                                </h3>
                                <v-table class="table table-mg table-sm">
                                    <v-thead>
                                        <v-tr>
                                            <v-th>{{
                                                $t("projects.employee")
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t("projects.time_customers")
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t("projects.time_internal")
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "projects.utilization_factor"
                                                )
                                            }}</v-th>
                                            <v-th></v-th>
                                        </v-tr>
                                    </v-thead>
                                    <v-tbody>
                                        <v-tr
                                            v-for="(d, udx) in meta.sums"
                                            :key="udx"
                                            :class="{
                                                'inactive-empl':
                                                    d.user.active == 0
                                            }"
                                        >
                                            <v-td>{{ d.user.name }} </v-td>
                                            <v-td class="text-right">{{
                                                d.billable | toTime
                                            }}</v-td>
                                            <v-td class="text-right">{{
                                                d.internal | toTime
                                            }}</v-td>
                                            <v-td class="text-right">
                                                {{ $n(d.factor, "twodec") }}%
                                            </v-td>
                                        </v-tr>
                                    </v-tbody>
                                </v-table>
                                <hr />
                            </div>

                            <div v-for="(e, idx) in rows" :key="idx">
                                <h3 class="mx-4">
                                    {{ $t("projects.period") }}:
                                    {{ e.month }}.{{ e.year }}
                                </h3>
                                <v-table class="table table-mg table-sm">
                                    <v-thead>
                                        <v-tr>
                                            <v-th>{{
                                                $t("projects.employee")
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t("projects.time_customers")
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t("projects.time_internal")
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t(
                                                    "projects.utilization_factor"
                                                )
                                            }}</v-th>
                                            <v-th></v-th>
                                        </v-tr>
                                    </v-thead>
                                    <v-tbody>
                                        <v-tr
                                            v-for="(d, udx) in e.entries"
                                            :key="udx"
                                            :class="{
                                                'inactive-empl':
                                                    d.user.active == 0
                                            }"
                                        >
                                            <v-td>{{ d.user.name }} </v-td>
                                            <v-td class="text-right">{{
                                                d.billable | toTime
                                            }}</v-td>
                                            <v-td class="text-right">{{
                                                d.internal | toTime
                                            }}</v-td>
                                            <v-td class="text-right"
                                                >{{
                                                    $n(d.factor, "twodec")
                                                }}%</v-td
                                            >
                                        </v-tr>
                                    </v-tbody>
                                </v-table>
                                <hr />
                            </div>
                        </template>
                        <template v-else>
                            <div class="mx-4 alert alert-warning">
                                {{
                                    $t(
                                        "projects.no_data_found_please_select_time_range_and_department"
                                    )
                                }}
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.inactive-empl {
    td {
        background: $gray-100;
        color: $gray-700;
    }
}
</style>
